<template>
    <div class="popupover chooseCountry-box scroll-container" v-if="isShow" id="chooseCountry">
        <div class="popup-bg" @click="onCountryClose()"></div>
        <div class="popupover-m chooseCountry">
            <div class="popupover-close js-chooseCountryClose" @click="onCountryClose()">
                <img src="https://resource.rcclchina.com.cn/RcclHP/icon17.png" class="">
            </div>

            <div class="chooseCountry-m">
                <div class="chooseCountry-title">
                    <div class="chooseCountry-tab" :class="{active: tab=='cn'}" @click="tab='cn'" data-el="CN">国内/港澳台</div>
                    <div class="chooseCountry-tab" :class="{active: tab!='cn'}" @click="tab='other'"  data-el="overseas">海外</div>
                </div>

                <div class="chooseCountry-content">
                    <div class="chooseCountry-tabCell js-smartScroll" v-show="tab=='cn'" id="chooseCountry-CN">
                        <div class="chooseCountry-cell" v-for="country in cnCountries" 
                        :key="('country_'+country.countryCode)"
                        @click="onCountrySelected(country.countryCode)">
                            {{country.countryName}}
                        </div>
                    </div>

                    <div class="chooseCountry-tabCell chooseCountry-tabCell-overseas js-smartScroll" v-show="tab!='cn'" ref="chooseOtherCountry">
                        <div class="chooseCountry-cell-box" v-for="letter in letters" :key="('country_letter_'+letter)">
                            <div :ref="('countryLetter' + letter)" class="chooseCountry-cell-title">{{letter}}</div>
                                <div class="chooseCountry-cell" 
                                    v-for="(country) in getContriesByLetter(letter)"
                                    :key="('country_' + country.countryCode)"
                                    @click="onCountrySelected(country.countryCode)">
                                    {{country.countryName}}
                                </div>
                        </div>
                    </div>

                    <div class="chooseCountry-letter" v-show="tab!='cn'" >
                        <div class="chooseCountry-letter-m"> 
                            <div class="chooseCountry-letter-cell" 
                                v-for="letter in letters" 
                                :key="('letter_'+letter)"
                                @click="goToLetterTab(letter)"
                            >
                                {{letter}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
export default {
    name: "CountrySelector",
    props: {
        isShow: {
            type: Boolean,
            default () {
                return false
            }
        },
        onCountrySelected: {
            type: Function
        },
        onCountryClose: {
            type: Function
        }
    },
    data () {
        return {
            letters: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
            tab: 'cn'
        }
    },
    mounted () {
        if (this.otherCountries && this.otherCountries.length > 0) {
            let letters = []
            this.otherCountries.forEach((country) => {
                if (country.pinyinName && country.pinyinName.length > 0) {
                    const letter = country.pinyinName.substr(0, 1).toUpperCase()
                    if (letters.indexOf(letter) < 0) {
                        letters.push(letter)
                    }
                }
            })
            this.letters = _.orderBy(letters)
        }
    },
    methods: {
        getContriesByLetter(letter) {
            let countries = this.otherCountries.
            filter(r=>r.pinyinName && (r.pinyinName.indexOf(letter) == 0 || r.pinyinName.indexOf(letter.toLowerCase()) == 0))
            return countries
        },
        goToLetterTab(letter) {
            const letterTab = this.$refs['countryLetter' + letter]
            if (letterTab && letterTab.length > 0) {
                this.$refs.chooseOtherCountry.scroll({
                    top: letterTab[0].offsetTop, 
                    behavior: 'smooth'
                })
            }
        }
    },
    computed: {
        countries() {
            return this.$store.state.page.countries
        },
        cnCountries () {
            const cn = ['CN', 'HK', 'MAC', 'TWN']
            return this.countries.filter(r=>cn.indexOf(r.countryCode) >= 0)
        },
        otherCountries () {
            const cn = ['CN', 'HK', 'MAC', 'TWN']
            return this.countries.filter(r=>cn.indexOf(r.countryCode) < 0)
        }
    },
    watch: {
        isShow(newValue) {
            // 每次打开，默认选中国内
            if (newValue) {
                this.tab = 'cn'
            }
        }
    }
}
</script>

<style lang="less" scoped>
.popupover {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10401;
    width: 100%;
    height: 100%;
    
    .popup-bg {
        position: absolute;
        left: 0; 
        top:0;
        height: 100%;
        width: 100%;
        background-color: rgba(21, 22, 29, 0.6);
    }
    .popupover-m {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        background-color: #fff;
        border-top: 5px solid #FEBC10;
        .popupover-close {
            position: absolute;
            right: 0;
            top: -1px;
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -webkit-justify-content: center;
            -moz-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            width: 30px;
            height: 30px;
            background-color: #FEBC10;
            border-bottom-left-radius: 5px;
            img {
                width: 17px;
            }
        }
        .chooseCountry-m {
            .chooseCountry-title {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                padding: 0 20px;
                .chooseCountry-tab {
                    -webkit-box-flex: 1;
                    -webkit-flex: 1;
                    -moz-box-flex: 1;
                    -ms-flex: 1;
                    flex: 1;
                    padding-top: 25px;
                    padding-bottom: 15px;
                    font-size: 14px;
                    line-height: 20px;
                    color: #333;
                    text-align: center;
                    border-bottom: 1px solid #E5E5E5;
                }
                .chooseCountry-tab.active {
                    padding-bottom: 14px;
                    color: #4A90E2;
                    font-weight: bold;
                    border-bottom: 2px solid #4A90E2;
                }
            }
            .chooseCountry-content {
                position: relative;
                height: 70vh;
                .chooseCountry-tabCell {
                    position: relative;
                    height: 100%;
                    overflow-y: auto;
                    .chooseCountry-cell-title {
                        width: 332px;
                        padding-left: 20px;
                        font-size: 14px;
                        line-height: 20px;
                        color: #333;
                        background-color: #F0F0F0;
                    }
                    .chooseCountry-cell {
                        position: relative;
                        display: -webkit-box;
                        display: -webkit-flex;
                        display: -moz-box;
                        display: -ms-flexbox;
                        display: flex;
                        -webkit-box-align: center;
                        -webkit-align-items: center;
                        -moz-box-align: center;
                        -ms-flex-align: center;
                        align-items: center;
                        height: 74px;
                        margin: 0 40px 0 20px;
                        font-size: 14px;
                        line-height: 20px;
                        color: #333;
                        border-bottom: 1px solid #E5E5E5;
                    }
                }
                .chooseCountry-letter {
                    position: absolute;
                    top: 0px;
                    right: 19px;
                    height: 100%;
                    font-size: 12px;
                    line-height: 1;
                    color: #4A90E2;
                    text-align: center;
                    .chooseCountry-letter-m {
                        display: -webkit-box;
                        display: -webkit-flex;
                        display: -moz-box;
                        display: -ms-flexbox;
                        display: flex;
                        -webkit-box-orient: vertical;
                        -webkit-box-direction: normal;
                        -webkit-flex-direction: column;
                        -moz-box-orient: vertical;
                        -moz-box-direction: normal;
                        -ms-flex-direction: column;
                        flex-direction: column;
                        height: 100%;
                        .chooseCountry-letter-cell {
                            -webkit-box-flex: 1;
                            -webkit-flex: 1;
                            -moz-box-flex: 1;
                            -ms-flex: 1;
                            flex: 1;
                            display: -webkit-box;
                            display: -webkit-flex;
                            display: -moz-box;
                            display: -ms-flexbox;
                            display: flex;
                            -webkit-box-align: center;
                            -webkit-align-items: center;
                            -moz-box-align: center;
                            -ms-flex-align: center;
                            align-items: center;
                        }
                    }
                }
            }
        }
    }
}
</style>